export function normalizeCurrency(currency) {
    switch (currency) {
        case "Kč":
            return "CZK";
        case "€":
            return "EUR";
        case "$":
            return "USD";
        default:
            return currency.toUpperCase();
    }
}

export function formatAmount(value, currency) {
    if (!currency) {
        return value?.toFixed(2);
    }
    return currency + " " + value?.toFixed(2);


    const normalizedCurrency = normalizeCurrency(currency);

    let locale;
    switch (normalizedCurrency) {
        case "CZK":
        case "EUR":
            locale = "cs-CZ"; break;
        case "USD":
            locale = "en-US"; break;
        default:
            locale = undefined;
    }

    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: normalizedCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
}